import Modal from '@/components/modal/modal.component'
import ContactUsForm from '@/components/SHARED/contact-us/contact-us-form.component'
import React from 'react'
import { useSelector } from 'react-redux';

const FeedbackModal = ({
    show,
    cancel
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);

  return (
    <div className='feedback-modal'>
        <Modal 
            show={show} 
            cancel={cancel}
            closeButton={true}
            text="Send Us Feedback"
            cls={screenSize ==='tablet' ? 'wide' : 'narrow'}
            >
            <ContactUsForm 
                tall={true}
                cancel={cancel} />
        </Modal>
    </div>
  )
}

export default FeedbackModal